import { useState, useCallback } from "react";

import ResultsTotal, { ShowingNumber } from "../../components/ResultsTotal";
import { useCachedInfiniteHits } from "../../hooks/useCachedInfiniteHits";

export function InfinitePagination() {
  const { isLastPage, showMore } = useCachedInfiniteHits();
  const [loading, setLoading] = useState(false);

  const handleLoadMore = useCallback(async () => {
    if (isLastPage) return;
    setLoading(true);

    const scrollY = window.scrollY;
    await showMore();
    requestAnimationFrame(() => {
      window.scrollTo({ top: scrollY, behavior: "instant" });
      setLoading(false);
    });
  }, [isLastPage, showMore]);

  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-flex-col tw-my-16 tw-space-y-4">
      <div className="tw-text-center">
        <p className="tw-text-xs">Showing <ShowingNumber /> of <ResultsTotal /></p>
      </div>

      {!isLastPage && (
        <button
          onClick={handleLoadMore}
          disabled={loading}
          className="tw-bg-black tw-text-white tw-px-14 tw-pt-3 tw-pb-4 tw-text-base tw-disabled:opacity-50 tw-align-middle tw-leading-none"
          aria-busy={loading}
        >
          {loading ? "Loading..." : "Load More"}
        </button>
      )}
    </div>
  );
}